/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export { discriminators, ADGroup, Application, AppRole, CloudError, DirectoryObject, DirectoryObjectListResult, GetObjectsParameters, InformationalUrl, KeyCredential, OAuth2Permission, OptionalClaim, OptionalClaims, PasswordCredential, PreAuthorizedApplication, PreAuthorizedApplicationExtension, PreAuthorizedApplicationPermission, RequiredResourceAccess, ResourceAccess, ServicePrincipal, SignInName, User } from "../models/mappers";
//# sourceMappingURL=objectsMappers.js.map